import{__assign as o}from'./../../ext-esm/tslib/tslib.es6.js';import s from"prop-types";var e={white:s.bool,size:s.number},r=o(o({},e),{className:s.string});export{e as loaderPropTypes,r as screenLoadingIndicatorPropTypes};
